module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("\n    type:\n    "), _vm._l((_vm.types), function(t) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.type),
        expression: "type"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": t,
        "checked": _vm._q(_vm.type, t)
      },
      on: {
        "__c": function($event) {
          _vm.type = t
        }
      }
    }), _vm._v("\n      " + _vm._s(t) + "\n    ")])
  })], 2), _vm._v("\n  A "), _c('a', {
    attrs: {
      "href": "https://json-schema-editor.tangramjs.com/editor.html",
      "target": "_blank"
    }
  }, [_vm._v("JSON schema editor")]), _vm._v(" maybe useful.\n  "), _c('div', [_c('label', [_vm._v("host: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.host),
      expression: "host"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.host = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.hosts), function(host) {
    return _c('option', [_vm._v(_vm._s(host))])
  }))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.url))]), _vm._v(" "), _c('codemirror', {
    attrs: {
      "options": _vm.editorOptions
    },
    on: {
      "ready": _vm.onReady
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec6ac5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeEditor.vue
// module id = 285
// module chunks = 1